<template>
    <div
        :class="brokenClass"
        class="analytics-practice-streak">
        <div class="analytics-practice-streak__record">
            <div
                v-if="showPreloader"
                class="analytics-practice-streak__record-preloader"></div>
            <template v-if="!showPreloader">
                <span class="analytics-practice-streak__record-label">{{ textRecordLabel }}</span>
                <span class="analytics-practice-streak__record-value">{{ filteredPracticeStreakData.record.streak }}</span>
                <span
                    v-if="showRecordPeriod"
                    class="analytics-practice-streak__record-period">{{ textRecordPeriod }}</span>
                <div class="analytics-practice-streak__record-wings">
                    <svg class="analytics-practice-streak__record-wings-art" width="124" height="124" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_1169_2780" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="124" height="124"><circle cx="62" cy="62" r="62" fill="#D9D9D9"/></mask><g mask="url(#mask0_1169_2780)"><path class="art-analytics-practice-record-wings__wing-right" fill="#FCCD1D" d="M25.41 163L145.4 43.011l16.97 16.97-119.988 119.99z"/><path class="art-analytics-practice-record-wings__wing-right" fill="#FCCD1D" d="M-38.59 60L81.4 179.989l16.97-16.97-119.99-119.99z"/></g><mask id="mask1_1169_2780" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="25" y="40" width="74" height="77"><ellipse cx="62" cy="78.5" rx="37" ry="38.5" fill="#D9D9D9"/></mask><g mask="url(#mask1_1169_2780)"><path class="art-analytics-practice-record-wings__wing-left" fill="#FCCD1D" d="M40.162 141.218l71.607-74.51 10.127 10.539-71.606 74.51z"/><path class="art-analytics-practice-record-wings__wing-left" fill="#FCCD1D" d="M1.969 77.258l71.606 74.51 10.128-10.539L12.096 66.72z"/></g></svg>
                </div>
                <span class="analytics-practice-streak__scratch--left"></span>
                <span class="analytics-practice-streak__scratch--right"></span>
            </template>
        </div>
        <div class="analytics-practice-streak__progressbar">
            <span
                :style="progressbarWidth"
                class="analytics-practice-streak__progressbar-indicator"></span>
            <svg class="analytics-practice-streak__progressbar-icon" width="35" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.037 47.17l-6.019-3.795L12 47.17V21.755h12.037V47.17z" fill="#285FFF"/><path class="analytics-practice-streak__progressbar-icon-outer-circle" d="M17.5 35C27.165 35 35 27.165 35 17.5S27.165 0 17.5 0 0 7.835 0 17.5 7.835 35 17.5 35z" fill="#FAFAFA"/><path class="analytics-practice-streak__progressbar-icon-inner-circle" d="M17.5 30.36c7.102 0 12.86-5.758 12.86-12.86 0-7.102-5.758-12.86-12.86-12.86-7.102 0-12.86 5.758-12.86 12.86 0 7.102 5.758 12.86 12.86 12.86z" fill="#AAA"/><path class="analytics-practice-streak__progressbar-icon-star" d="M18.742 10.647l1.366 2.337a1.423 1.423 0 00.96.677l2.743.542a1.377 1.377 0 01.757 2.258l-1.886 2.01a1.377 1.377 0 00-.372 1.129l.327 2.71a1.422 1.422 0 01-2.01 1.434l-2.528-1.13a1.467 1.467 0 00-1.197 0l-2.53 1.13a1.423 1.423 0 01-2.009-1.434l.328-2.71a1.376 1.376 0 00-.373-1.13l-1.886-2.009a1.377 1.377 0 01.757-2.258l2.743-.542a1.422 1.422 0 00.96-.677l1.366-2.383a1.446 1.446 0 012.484.046z" fill="#EEE"/></svg>
        </div>
        <div
            v-if="showRemaining"
            class="analytics-practice-streak__remaining">
            <span class="analytics-practice-streak__remaining-label">KALAN</span>
            <span
                v-if="!showPreloader"
                class="analytics-practice-streak__remaining-value">{{ filteredPracticeStreakData.remaining }} pratik daha</span>
            <div
                v-if="showPreloader"
                class="analytics-practice-streak__remaining-preloader"></div>
        </div>
        <div class="analytics-practice-streak__current-period">
            <div
                v-if="showPreloader"
                class="analytics-practice-streak__current-period-preloader"></div>
            <template v-if="!showPreloader">
                <span class="analytics-practice-streak__current-period-value">{{ textCurrentPeriod }}</span>
                <span class="analytics-practice-streak__current-period-date">{{ textCurrentDate }}</span>
            </template>
        </div>
        <div class="analytics-practice-streak__stars--left">
            <svg class="analytics-practice-streak__star-01" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1159_2744)"><path d="M16.132 4.935a.985.985 0 00-1.024-.06l-3.787 2.018L7.366 4.78a.984.984 0 00-1.429 1.066l.901 4.393-3.012 3.057a.984.984 0 00.548 1.663l4.383.693 2.1 4.04a.987.987 0 001.772-.049l1.78-3.937 4.28-.586a.984.984 0 00.552-1.685l-3.277-3.162.583-4.4a.985.985 0 00-.415-.938z" fill="#FF68DE"/></g><defs><clipPath id="clip0_1159_2744"><path fill="#fff" transform="rotate(-36.735 14.411 4.785)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
            <svg class="analytics-practice-streak__star-02" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1159_2744)"><path d="M16.132 4.935a.985.985 0 00-1.024-.06l-3.787 2.018L7.366 4.78a.984.984 0 00-1.429 1.066l.901 4.393-3.012 3.057a.984.984 0 00.548 1.663l4.383.693 2.1 4.04a.987.987 0 001.772-.049l1.78-3.937 4.28-.586a.984.984 0 00.552-1.685l-3.277-3.162.583-4.4a.985.985 0 00-.415-.938z" fill="#FF68DE"/></g><defs><clipPath id="clip0_1159_2744"><path fill="#fff" transform="rotate(-36.735 14.411 4.785)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
            <svg class="analytics-practice-streak__star-03" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1159_2744)"><path d="M16.132 4.935a.985.985 0 00-1.024-.06l-3.787 2.018L7.366 4.78a.984.984 0 00-1.429 1.066l.901 4.393-3.012 3.057a.984.984 0 00.548 1.663l4.383.693 2.1 4.04a.987.987 0 001.772-.049l1.78-3.937 4.28-.586a.984.984 0 00.552-1.685l-3.277-3.162.583-4.4a.985.985 0 00-.415-.938z" fill="#FF68DE"/></g><defs><clipPath id="clip0_1159_2744"><path fill="#fff" transform="rotate(-36.735 14.411 4.785)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
        </div>
        <div class="analytics-practice-streak__stars--right">
            <svg class="analytics-practice-streak__star-01" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1159_2744)"><path d="M16.132 4.935a.985.985 0 00-1.024-.06l-3.787 2.018L7.366 4.78a.984.984 0 00-1.429 1.066l.901 4.393-3.012 3.057a.984.984 0 00.548 1.663l4.383.693 2.1 4.04a.987.987 0 001.772-.049l1.78-3.937 4.28-.586a.984.984 0 00.552-1.685l-3.277-3.162.583-4.4a.985.985 0 00-.415-.938z" fill="#FF68DE"/></g><defs><clipPath id="clip0_1159_2744"><path fill="#fff" transform="rotate(-36.735 14.411 4.785)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
            <svg class="analytics-practice-streak__star-02" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1159_2744)"><path d="M16.132 4.935a.985.985 0 00-1.024-.06l-3.787 2.018L7.366 4.78a.984.984 0 00-1.429 1.066l.901 4.393-3.012 3.057a.984.984 0 00.548 1.663l4.383.693 2.1 4.04a.987.987 0 001.772-.049l1.78-3.937 4.28-.586a.984.984 0 00.552-1.685l-3.277-3.162.583-4.4a.985.985 0 00-.415-.938z" fill="#FF68DE"/></g><defs><clipPath id="clip0_1159_2744"><path fill="#fff" transform="rotate(-36.735 14.411 4.785)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
            <svg class="analytics-practice-streak__star-03" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1159_2744)"><path d="M16.132 4.935a.985.985 0 00-1.024-.06l-3.787 2.018L7.366 4.78a.984.984 0 00-1.429 1.066l.901 4.393-3.012 3.057a.984.984 0 00.548 1.663l4.383.693 2.1 4.04a.987.987 0 001.772-.049l1.78-3.937 4.28-.586a.984.984 0 00.552-1.685l-3.277-3.162.583-4.4a.985.985 0 00-.415-.938z" fill="#FF68DE"/></g><defs><clipPath id="clip0_1159_2744"><path fill="#fff" transform="rotate(-36.735 14.411 4.785)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';

    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            showRecordPeriod(){
                return this.filteredPracticeStreakData.broken ? false : true;
            },

            showRemaining(){
                if(this.showPreloader){
                    return true;
                }
                return this.filteredPracticeStreakData.broken ? false : true;
            },

            filteredPracticeStreakData(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                return this.$store.state.response.analyticsPractice.practiceStreakData[selectedFiltertagType];
            },

            textRecordLabel(){
                return this.filteredPracticeStreakData.broken
                       ? 'GÜNCEL REKOR'
                       : 'SON REKOR';
            },

            textRecordPeriod(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'HAFTA #' + this.filteredPracticeStreakData.record.period;
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'AY: ' + this.filteredPracticeStreakData.record.period;
                }
            },

            textCurrentPeriod(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'HAFTA #' + this.filteredPracticeStreakData.current.period;
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'AY: ' + this.filteredPracticeStreakData.current.period;
                }
            },

            textCurrentDate(){
                return moment().format('DD.MM.YYYY');
            },

            progressbarWidth(){
                if(this.showPreloader){
                    return 'width: 0px';
                }

                if(this.filteredPracticeStreakData.broken){
                    return 'width: 100%';
                }
                
                let targetStreak = this.filteredPracticeStreakData.record.streak + 1;
                let curStreak    = this.filteredPracticeStreakData.current.streak;
                let progressPercent = Math.floor((curStreak / targetStreak) * 100);

                const maxProgressbarWidth = 280;
                let progressbarWidth = (maxProgressbarWidth / 100) * progressPercent;
                
                return 'width: ' + Math.floor(progressbarWidth) + 'px';
            },

            brokenClass(){
                if(this.showPreloader){
                    return '';
                }
                return this.filteredPracticeStreakData.broken
                       ? 'analytics-practice-streak--broken'
                       : '';
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsPracticeStreakUnbroken)
                .then(response => response.json())
                .then(practiceStreakData => {
                    this.$store.commit('setResponseAnalyticsPracticePracticeStreakData', practiceStreakData);
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPracticeStreak, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(practiceStreakData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'practiceStreakData',
                        data: practiceStreakData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-practice-streak.css"></style>